export function handleProcessFilters(setActiveFilters, filterName, value) {
  setActiveFilters((prev) => {
    // Find the index of the filter object with the given filterName
    const filterIndex = prev.findIndex((f) => f.filterName === filterName);

    if (filterIndex !== -1) {
      // If the filter object exists, update its 'selectedFilters'
      const updatedFilters = prev
        .map((filter, index) => {
          if (index === filterIndex) {
            // If an empty array is passed, remove the filter object
            if (Array.isArray(value) && value.length === 0) {
              return null;
            }
            
            // If value is an array, use it directly
            if (Array.isArray(value)) {
              return {
                ...filter,
                selectedFilters: value
              };
            }
            
            // For single values, toggle them in the array
            const updatedSelectedFilters = filter.selectedFilters.includes(value)
              ? filter.selectedFilters.filter((v) => v !== value)
              : [...filter.selectedFilters, value];

            return {
              ...filter,
              selectedFilters: updatedSelectedFilters,
            };
          }
          return filter;
        })
        .filter(
          (filter) => filter !== null && filter.selectedFilters.length > 0
        );

      return updatedFilters;
    }

    // If an empty array is passed for a new filter, just return the previous state
    if (Array.isArray(value) && value.length === 0) {
      return prev;
    }

    // If the filter object doesn't exist, add a new one
    return [...prev, { 
      filterName, 
      selectedFilters: Array.isArray(value) ? value : [value] 
    }];
  });
}
